import { useEffect, useState } from "react";

/**
 * Once `value` is true, the returned value stays true forever — even if
 * `value` later goes back to false. Used to defer mounting a lazy-loaded
 * dialog until the moment a caller first asks to open it, without
 * unmounting it (and losing MUI's close transition) on every subsequent
 * close.
 */
export function useStickyTrue(value: boolean): boolean {
  const [everTrue, setEverTrue] = useState(value);

  useEffect(() => {
    if (value) {
      setEverTrue(true);
    }
  }, [value]);

  return everTrue;
}
